import { Controller } from "stimulus";
var onmount = require("onmount");

export default class extends Controller {
  static values = {
    url: String,
    date: String,
  };

  static targets = ["dateLabel", "content", "todayButton", "listBtn", "summaryBtn"];

  localDateString(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }

  connect() {
    this.activeView = "list";
    this.handleAttendanceChanged = this.onAttendanceChanged.bind(this);
    document.addEventListener("attendanceChanged", this.handleAttendanceChanged);

    this.boundDismissPopovers = function (e) {
      if (!$(e.target).closest('[data-toggle="popover-clickable"], .popover').length) {
        $('[data-toggle="popover-clickable"]').data('pinned', false).popover('hide');
      }
    };
    $(document).on('click', this.boundDismissPopovers);

    this.loadContent();
  }

  showList() {
    this.activeView = "list";
    this.updateViewButtons();
    var $content = $(this.contentTarget);
    $content.find('#in-facility-list').removeClass('d-none');
    $content.find('#in-facility-summary').addClass('d-none');
  }

  showSummary() {
    this.activeView = "summary";
    this.updateViewButtons();
    var $content = $(this.contentTarget);
    $content.find('#in-facility-list').addClass('d-none');
    $content.find('#in-facility-summary').removeClass('d-none');
  }

  updateViewButtons() {
    if (this.hasListBtnTarget && this.hasSummaryBtnTarget) {
      if (this.activeView === "summary") {
        $(this.summaryBtnTarget).removeClass('btn-light').addClass('btn-primary');
        $(this.listBtnTarget).removeClass('btn-primary').addClass('btn-light');
      } else {
        $(this.listBtnTarget).removeClass('btn-light').addClass('btn-primary');
        $(this.summaryBtnTarget).removeClass('btn-primary').addClass('btn-light');
      }
    }
  }

  previous() {
    this.dateValue = this.offsetDate(-1);
    this.loadContent();
  }

  next() {
    this.dateValue = this.offsetDate(1);
    this.loadContent();
  }

  gotoToday() {
    this.dateValue = this.localDateString(new Date());
    this.loadContent();
  }

  pickDate() {
    var controller = this;

    if (this.flatpickrInstance) {
      this.flatpickrInstance.open();
      return;
    }

    this.flatpickrInstance = flatpickr(this.dateLabelTarget, {
      disableMobile: "true",
      defaultDate: this.dateValue,
      onChange: function (selectedDates) {
        if (selectedDates.length === 1) {
          controller.dateValue = controller.localDateString(selectedDates[0]);
          controller.loadContent();
        }
      },
    });

    this.flatpickrInstance.open();
  }

  disconnect() {
    document.removeEventListener("attendanceChanged", this.handleAttendanceChanged);
    $(document).off('click', this.boundDismissPopovers);
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
      this.flatpickrInstance = null;
    }
  }

  onAttendanceChanged() {
    this.loadContent();
  }

  loadContent() {
    var controller = this;
    var url = this.urlValue;

    if (url.indexOf("?") !== -1) {
      url = url + "&date=" + this.dateValue;
    } else {
      url = url + "?date=" + this.dateValue;
    }

    if (this.activeView === "summary") {
      url = url + "&view=summary";
    }

    this.contentTarget.innerHTML =
      '<div class="text-center"><div class="spinner spinner-border spinner-border-sm text-primary mx-auto my-4"></div></div>';

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function (xhr) {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: function (html) {
        controller.contentTarget.innerHTML = html;
        controller.updateDateLabel();
        controller.updateTodayVisibility();
        controller.syncFlatpickr();
        var $content = $(controller.contentTarget);
        $content.find('[data-toggle="tooltip"]').tooltip({ sanitize: false });
        $content.find('[data-toggle="popover"]').popover({ sanitize: false });
        $content.find('[data-toggle="popover-clickable"]').popover({ sanitize: false, trigger: 'manual' }).on('mouseenter', function () {
          var $this = $(this);
          if (!$this.data('pinned')) {
            $this.popover('show');
          }
        }).on('mouseleave', function () {
          var $this = $(this);
          if (!$this.data('pinned')) {
            $this.popover('hide');
          }
        }).on('click', function (e) {
          e.preventDefault();
          var $this = $(this);
          if ($this.data('pinned')) {
            $this.data('pinned', false).popover('hide');
          } else {
            $('[data-toggle="popover-clickable"]').data('pinned', false).popover('hide');
            $this.data('pinned', true).popover('show');
          }
        });
        onmount();
      },
      error: function () {
        window.notyf.error(
          "Something went wrong when loading your request. Please try again."
        );
      },
    });
  }

  updateDateLabel() {
    var date = new Date(this.dateValue + "T00:00:00");
    var options = { weekday: "short", month: "short", day: "numeric" };
    var formatted = date.toLocaleDateString("en-US", options);
    this.dateLabelTarget.childNodes[0].textContent = formatted;
  }

  updateTodayVisibility() {
    var today = this.localDateString(new Date());
    var isToday = this.dateValue === today;

    if (isToday) {
      $(this.todayButtonTarget).addClass("d-none");
    } else {
      $(this.todayButtonTarget).removeClass("d-none");
    }
  }

  syncFlatpickr() {
    if (this.flatpickrInstance) {
      this.flatpickrInstance.setDate(this.dateValue, false);
    }
  }

  offsetDate(days) {
    var date = new Date(this.dateValue + "T00:00:00");
    date.setDate(date.getDate() + days);
    return this.localDateString(date);
  }
}
